export const settingsQueryKeys = {
  all: ["settings"],
  lists: () => [...settingsQueryKeys.all, "list"],
  list: () => [...settingsQueryKeys.lists(), "all"],
  visible: () => [...settingsQueryKeys.lists(), "visible"],
  sidemenu: () => [...settingsQueryKeys.all, "sidemenu"],
  targetGroups: () => [...settingsQueryKeys.all, "target-groups"],
};
